export type QROrderDirection = 'asc' | 'desc';

export class QRButtonOrder {
  hintLabel = 'Orden';
}
